// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  /* no scroll bars */
  overflow: hidden;
  color: rgb(53, 48, 48);
}

#app {
  display: flex;
  width: 100%;
  flex-direction: row;
}

.snow-layers-gap {

  h2 {
    font-size: 24px;
    font-weight: 700;
    /* margin-bottom: 16px;margin */
    display: inline-block;
    /* padding: 16px 32px; */
    padding-left: 16px;
    padding-right: 16px;
  }

  /* button {
    display: inline-block;
  } */

  .layers-header {
    padding-bottom: 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 56px;

    button {
      margin-right: 8px;
    }

    h2 {
      color: rgb(53, 48, 48);
    }
  }
}

.layers-container {
  background-color: #f5f5f5;
  padding: 8px 16px 56px 16px;
}

.primary {
  background-color: #8d90b7;
}

.secondary {
  /* background-color: #ffffff; */
  background-color: #f5f5f5;
}

.white {
  background-color: #ffffff;
}

.grey-1 {
  background-color: #f5f5f5;
}

.grey-2 {
  background-color: #e3e3e3;
}

.grey-3 {
  background-color: #d1d1d1;
}

.grey-4 {
  background-color: #bfbfbf;
}

.grey-5 {
  background-color: #adadad;
}

@media (max-width:1050px)  { 
  #app {
    flex-direction: column-reverse;
  }
}`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE;IACE,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;KAEG;;EAEH;IACE,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;;IAEhB;MACE,iBAAiB;IACnB;;IAEA;MACE,sBAAsB;IACxB;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":["body {\n  /* no scroll bars */\n  overflow: hidden;\n  color: rgb(53, 48, 48);\n}\n\n#app {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n}\n\n.snow-layers-gap {\n\n  h2 {\n    font-size: 24px;\n    font-weight: 700;\n    /* margin-bottom: 16px;margin */\n    display: inline-block;\n    /* padding: 16px 32px; */\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  /* button {\n    display: inline-block;\n  } */\n\n  .layers-header {\n    padding-bottom: 16px;\n    display: flex;\n    justify-content: space-between;\n    margin-top: 56px;\n\n    button {\n      margin-right: 8px;\n    }\n\n    h2 {\n      color: rgb(53, 48, 48);\n    }\n  }\n}\n\n.layers-container {\n  background-color: #f5f5f5;\n  padding: 8px 16px 56px 16px;\n}\n\n.primary {\n  background-color: #8d90b7;\n}\n\n.secondary {\n  /* background-color: #ffffff; */\n  background-color: #f5f5f5;\n}\n\n.white {\n  background-color: #ffffff;\n}\n\n.grey-1 {\n  background-color: #f5f5f5;\n}\n\n.grey-2 {\n  background-color: #e3e3e3;\n}\n\n.grey-3 {\n  background-color: #d1d1d1;\n}\n\n.grey-4 {\n  background-color: #bfbfbf;\n}\n\n.grey-5 {\n  background-color: #adadad;\n}\n\n@media (max-width:1050px)  { \n  #app {\n    flex-direction: column-reverse;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
